
import AdUnit from '../components/AdUnit';
import React, { useEffect, useState } from 'react';
import useReveal from '../hooks/useReveal';
import { PageHero, FAQList } from '../components/shared';
import SaveButton from '../components/SaveButton';
import AffiliateBlock from '../components/AffiliateBlock';
import AdSlot from '../components/AdSlot';
import LeadForm from '../components/LeadForm';
import { GraduationCap, HeartPulse } from 'lucide-react';
import { LIVING_PAGE } from '../mock';
import { fetchFaqs } from '../api';

const Living = () => {
  const p = LIVING_PAGE;
  const [faqs, setFaqs] = useState(p.faqs);
  useReveal([]);
  useEffect(() => {
    fetchFaqs('living').then((d) => d.length && setFaqs(d)).catch(() => {});
  }, []);
  return (
    <div className="bg-[#F6F1E3]">
      <PageHero image={p.hero} alt="Palm Jumeirah aerial" label={p.label} title={p.title} subtitle={p.subtitle} meta={p.meta} />
      <AdUnit slot="inline" />

      <article className="max-w-4xl mx-auto px-5 py-12 space-y-14">
        <div className="reveal flex justify-end">
          <SaveButton variant="pill" item={{ type: 'guide', ref_id: 'guide-living', title: p.title, subtitle: p.label, to: '/living' }} />
        </div>
        {/* Budgets */}
        <section>
          <h2 className="reveal font-display text-[28px] font-semibold text-[#1B1D21]">The real monthly budget</h2>
          <p className="reveal mt-3 text-[17px] leading-relaxed text-[#3a4f63]">
            Numbers below are realistic 2026 ranges in Dubai and Abu Dhabi. Smaller
            emirates run noticeably cheaper on rent. All figures are indicative.
          </p>
          <div className="mt-7 grid md:grid-cols-2 gap-6">
            {p.budgets.map((b) => (
              <div key={b.profile} className="reveal lift bg-white rounded-2xl border border-[#E6D7A2] overflow-hidden shadow-[0_18px_40px_-28px_rgba(27,29,33,0.45)]">
                <div className="sunset-gradient px-6 py-5">
                  <h3 className="font-display text-[22px] font-semibold text-white">{b.profile}</h3>
                  <p className="text-[15px] font-medium text-white/90 mt-1">{b.total}</p>
                </div>
                <ul className="divide-y divide-[#E6D7A2]">
                  {b.items.map((it) => (
                    <li key={it.label} className="flex items-center justify-between gap-4 px-6 py-3.5">
                      <span className="text-[15px] text-[#4B4F58]">{it.label}</span>
                      <span className="text-[15px] font-semibold text-[#1B1D21] text-right">{it.value}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        {/* Notes */}
        <section>
          <h2 className="reveal font-display text-[28px] font-semibold text-[#1B1D21]">What surprises people most</h2>
          <div className="mt-6 grid sm:grid-cols-2 gap-5">
            {p.notes.map((n) => (
              <div key={n.title} className="reveal rounded-2xl border border-[#E6D7A2] bg-[#EFE7D2] p-6">
                <h3 className="font-display text-[19px] font-semibold text-[#1B1D21]">{n.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-[#4B4F58]">{n.body}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="reveal">
          <h2 className="font-display text-[28px] font-semibold text-[#1B1D21] mb-5">Frequently asked questions</h2>
          <FAQList faqs={faqs} />
        </section>

        {/* Money & essentials (affiliate) */}
        <section className="reveal">
          <AffiliateBlock placement="living" title="Set up your money & cover" subtitle="What expats sort first — accounts and insurance." columns={2} />
        </section>

        {/* High-value lead-gen */}
        <section className="reveal grid md:grid-cols-2 gap-6">
          <LeadForm
            type="school"
            title="Find an international school"
            blurb="Tell us your children's ages and preferred emirate — we'll match you with suitable schools and current fee guidance."
            cta="Get school matches"
            icon={GraduationCap}
            accent="#2F663C"
          />
          <LeadForm
            type="insurance"
            title="Compare health insurance"
            blurb="Get tailored family or individual health-cover quotes from UAE-licensed providers."
            cta="Get insurance quotes"
            icon={HeartPulse}
            accent="#e0564e"
          />
        </section>

        <AdSlot slot="inContent" minH={140} className="reveal" />
      </article>
    </div>
  );
};

export default Living;
